module.exports = __webpack_public_path__ + "img/focus-possibility.7e66ce41.png";